// Mock analytics data generator
import { defaultAnalyticsData } from '../types/analyticsTypes';

const generateMockData = (timeframe) => {
  const days = timeframe === '7d' ? 7 : timeframe === '30d' ? 30 : 90;
  
  // Generate visitor trends
  const visitorTrends = [];
  const today = new Date();
  for (let i = days; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    visitorTrends.push({
      timestamp: date.toISOString(),
      value: Math.floor(Math.random() * 100) + 50
    });
  }
  
  // Calculate total visitors
  const totalVisitors = visitorTrends.reduce((sum, day) => sum + day.value, 0);
  
  // Generate geographic data
  const regions = ['North America', 'Europe', 'Asia', 'South America', 'Africa', 'Oceania'];
  const geographicData = regions.map(region => ({
    region,
    visitors: Math.floor(Math.random() * (totalVisitors / 3))
  }));
  
  // Ensure geographic data sums to total visitors
  const geoSum = geographicData.reduce((sum, region) => sum + region.visitors, 0);
  if (geoSum < totalVisitors) {
    geographicData[0].visitors += (totalVisitors - geoSum);
  }
  
  // Generate new vs returning
  const newVisitors = Math.floor(totalVisitors * 0.7);
  const returningVisitors = totalVisitors - newVisitors;
  
  return {
    ...defaultAnalyticsData,
    totalVisitors,
    visitorChange: Math.floor(Math.random() * 30) - 15,
    averageSessionDuration: `${Math.floor(Math.random() * 5) + 1}m ${Math.floor(Math.random() * 50)}s`,
    sessionDurationChange: Math.floor(Math.random() * 20) - 10,
    bounceRate: `${Math.floor(Math.random() * 40) + 30}%`,
    bounceRateChange: Math.floor(Math.random() * 10) - 5,
    conversionRate: `${Math.floor(Math.random() * 10) + 1}%`,
    conversionRateChange: Math.floor(Math.random() * 5) - 2,
    visitorTrends,
    geographicData,
    newVsReturning: {
      new: newVisitors,
      returning: returningVisitors
    },
    pageViews: {
      '/': { views: Math.floor(Math.random() * 1000) + 500 },
      '/our-story': { views: Math.floor(Math.random() * 500) + 200 },
      '/causes': { views: Math.floor(Math.random() * 400) + 150 },
      '/donate': { views: Math.floor(Math.random() * 300) + 100 },
      '/apply': { views: Math.floor(Math.random() * 200) + 50 },
    },
    visitorAnalytics: {
      visitorTrends,
      geographicData,
      newVsReturning: {
        new: newVisitors,
        returning: returningVisitors
      },
      totalVisitors,
      averageTimeOnSite: `${Math.floor(Math.random() * 5) + 1}m ${Math.floor(Math.random() * 50)}s`,
      bounceRate: `${Math.floor(Math.random() * 40) + 30}%`
    }
  };
};

export default generateMockData; 